<div id="physical-activity-chart"></div>
